import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IdentityService from '../../../apiclients/IdentityService';
import Loader from '../Loader';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { withStyles } from '@material-ui/core';
import AppContext from '../../../AppContext';
import { isAdmin, isEditor, isMtgOrColMine } from '../../../helpers';
import { IconButton } from '@projeccions-pdc/react-icon';
import './GroupSelector.css';

let queryCounter = 0;

let _groupsCache = {};

const styles = theme => ({
    chip: {
        margin: '5px 0px',
        verticalAlign: 'middle'
    },
    emptyChip: {
        margin: '5px 0px',
        verticalAlign: 'middle',
        padding: '3px'
    },
    root: {
        width: '100%'
    },
    listRoot: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300
    },
    underline: {
        borderBottom: '2px solid #000!important',
        color: '#000',
        '&:after': {
            borderBottom: 'none!important'
        },
        '&$error:after': {
            borderBottom: 'none!important'
        },
        '&:before': {
            borderBottom: 'none!important'
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: 'none!important'
        },
        '&$disabled:before': {
            borderBottom: 'none!important'
        }
    },
    disabled: {},
    focused: {},
    error: {},
    text: {
        color: '#000!important',
        textShadow: '1px 1px #3335',
        '&:focused': {
            color: '#000'
        }
    }
});

class GroupSelector extends Component {
    _groupId = null;

    constructor(props) {
        super(props);
        this.state = {
            searchResults: [],
            loading: false,
            searchValue: ''
        };

        this.closeNewItemPopOver = this.closeNewItemPopOver.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleGroupSelected = this.handleGroupSelected.bind(this);
    }

    componentDidMount() {
        this.getSelectedGroup(this.props.selectedGroup);
        this.getMyGroups();
    }

    componentWillUnmount() {
        this._groupId = null;
    }

    componentDidUpdate() {
        if (this.state.currGroup === undefined || this.props.selectedGroup !== this.state.currGroup.groupId) {
            this.getSelectedGroup(this.props.selectedGroup);
        }
    }

    getMyGroups = async () => {
        let groupIds = [];

        let appContext = new AppContext();
        let myInfo = appContext.getMyInfo();
        // myInfo.member.forEach(groupId => {
        //     if (groupIds.indexOf(groupId) === -1) {
        //         groupIds.push(groupId);
        //     }
        // });
        myInfo.editor.forEach(groupId => {
            if (groupIds.indexOf(groupId) === -1) {
                groupIds.push(groupId);
            }
        });

        let myGroups = [];
        for (let i = 0; i < groupIds.length; i++) {
            let groupId = groupIds[i];
            let response = await this.getGroupInfo(groupId);
            myGroups.push(response);
        }

        this.setState({ myGroups });
    };

    getSelectedGroup = async groupId => {
        if (groupId === this._groupId) {
            return;
        }
        this._groupId = groupId;
        if (groupId) {
            let response;
            if (isMtgOrColMine(groupId)) {
                let appContext = new AppContext();
                let myInfo = appContext.getMyInfo();
                response = {
                    name: myInfo.name,
                    groupId: groupId
                };
            } else {
                response = await this.getGroupInfo(groupId);
            }
            this.setState({ currGroup: response });
        } else {
            this.setState({ currGroup: undefined });
        }
    };

    getGroupInfo = async groupId => {
        if (_groupsCache[groupId]) {
            return _groupsCache[groupId];
        }
        try {
            let response = await IdentityService.getGroup(groupId);

            _groupsCache[groupId] = response;
            return response;
        } catch (err) {
            console.log(err);
            return {
                name: groupId,
                groupId: groupId
            };
        }
    };

    handleInputChange(evt) {
        let searchValue = evt.target.value;
        if (searchValue !== '') {
            if (isEditor() === true && isAdmin() === false) {
                this.setState({ loaded: true, searchValue, loading: false });
            } else {
                this.setState({ loaded: true, searchValue, loading: true });
                let lastQueryId = ++queryCounter;
                return IdentityService.searchGroups(searchValue)
                    .then(data => {
                        if (lastQueryId !== queryCounter) return;
                        //console.log(data);
                        this.setState({ loaded: true, loading: false, searchResults: data.items });
                    })
                    .catch(err => {
                        if (lastQueryId !== queryCounter) return;
                        console.log(err.message);
                    });
            }
        } else {
            this.setState({ loaded: false, searchValue, loading: false });
        }
    }

    handleFocus(evt) {
        // if (this.state.searchValue !== '') {
        this.setState({ loaded: true });
        // }
    }

    closeNewItemPopOver() {
        this.setState({ loaded: false });
    }

    handleGroupSelected(group) {
        this.props.onGroupSelected(group.groupId, group);
        this.setState({ loaded: false, searchValue: '', loading: true, searchResults: [] });
    }

    handleGroupRemoved = () => {
        this.props.removeGroup();
        this.setState({ loading: false, currGroup: undefined });
    };

    handleChangeGroup = () => {
        this.setState({ loaded: true });
    };

    renderPopOver = () => {
        let myGroups = this.state.myGroups;

        if (isAdmin()) {
            myGroups = this.state.myGroups.filter(group => {
                if (this.state.searchValue !== undefined && this.state.searchValue !== '') {
                    return group.name.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1;
                }
                return true;
            });
        }

        return (
            <Paper className="pdc-grselec-search-results" elevation={1}>
                <List className={this.props.classes.listRoot} component="nav">
                    {myGroups && <ListSubheader>My Groups</ListSubheader>}
                    {myGroups && (
                        <div>
                            {myGroups.map(result => {
                                return (
                                    <ListItem
                                        button
                                        key={result.groupId}
                                        onClick={() => {
                                            this.handleGroupSelected(result);
                                        }}
                                    >
                                        {result.name}
                                    </ListItem>
                                );
                            })}
                        </div>
                    )}
                    {this.state.searchResults && this.state.searchResults.length !== 0 && <Divider />}
                    {this.state.searchResults && this.state.searchResults.length !== 0 && <ListSubheader>Search results</ListSubheader>}
                    {this.state.searchResults && this.state.searchResults.length !== 0
                        ? this.state.searchResults.map(result => {
                              return (
                                  <ListItem
                                      button
                                      key={result.groupId}
                                      onClick={() => {
                                          this.handleGroupSelected(result);
                                      }}
                                  >
                                      {result.name}
                                  </ListItem>
                              );
                          })
                        : ''}
                    {(this.state.searchResults && this.state.searchResults.length !== 0) || this.state.myGroups ? (
                        ''
                    ) : (
                        <ListItem>No available results</ListItem>
                    )}
                </List>
            </Paper>
        );
    };

    render() {
        let inputProps = {
            classes: { underline: this.props.classes.underline, root: this.props.classes.root }
        };
        if (this.state.loading) {
            inputProps.endAdornment = (
                <InputAdornment position="end">
                    <Loader loading={this.state.loading} size="20px" />
                </InputAdornment>
            );
        }

        let onlyChange = isAdmin() === false && isEditor() === true;
        return (
            <ClickAwayListener onClickAway={this.closeNewItemPopOver}>
                <div className="pdc-grselec-container" data-id="groupSelector">
                    {this.state.currGroup ? (
                        <Chip
                            data-id="group-selected"
                            label={this.state.currGroup.name}
                            onDelete={
                                this.props.disabled === true ? undefined : onlyChange ? this.handleChangeGroup : this.handleGroupRemoved
                            }
                            className={this.props.classes.chip}
                            deleteIcon={onlyChange ? <IconButton name="md-edit" padding={15} /> : undefined}
                        />
                    ) : this.props.disabled === true ? (
                        // <span>{'Available for everyone'}</span>
                        <Chip data-id="group-available-for-everyone" label={'Available for everyone'} className={this.props.classes.chip} />
                    ) : (
                        <TextField
                            data-id="group-available-for-everyone"
                            type="text"
                            // className="pdc-grselec-input"
                            value={this.state.searchValue}
                            onChange={this.handleInputChange}
                            onFocus={this.handleFocus}
                            placeholder={'Available for everyone'}
                            InputProps={inputProps}
                            InputLabelProps={{ classes: { root: this.props.classes.text } }}
                            fullWidth
                        />
                    )}
                    {Boolean(this.state.loaded) && <div className="pdc-grselec-search-container">{this.renderPopOver()}</div>}
                </div>
            </ClickAwayListener>
        );
    }
}
GroupSelector.propTypes = {
    onGroupSelected: PropTypes.func.isRequired,
    selectedGroup: PropTypes.string,
    removeGroup: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool
};

export default withStyles(styles)(GroupSelector);
